import React from 'react';
import { AwardIcon, CheckIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { productBrand, productEdition, totalBonuses, totalVolumes } from '../data/offer';
export function SystemSection() {
  return <section className="border-y border-primary/40 bg-surface py-16 sm:py-20" aria-labelledby="system-title" data-id="element-191" data-mp="3bhbu9hm7k3fw">
      <div className="mx-auto max-w-4xl px-4 text-center" data-id="element-192" data-mp="36jjzmfu6i380">
        <span className="inline-flex items-center gap-2 rounded-full border border-accent/50 bg-background/40 px-4 py-2 text-xs font-extrabold uppercase tracking-[.12em] text-foreground" data-id="element-193" data-mp="31lqyi17qfzel">
          <AwardIcon className="h-4 w-4 shrink-0 text-accent" aria-hidden="true" data-id="element-194" data-mp="2srm0mxu6lnpk" /> The Complete Visual Chemistry Teaching System
        </span>
        <SectionHeading id="system-title" className="mt-6" data-id="element-195" data-mp="2nv5bq1f5r5bf">
          {productBrand} — <span className="text-accent" data-id="element-196" data-mp="2iswhz2ugnz89">{productEdition}</span>
        </SectionHeading>
        <p className="mt-4 font-semibold text-muted" data-id="element-197" data-mp="2dw62agmkj5nd">
          {totalVolumes} volumes · {totalBonuses} exclusive bonuses
        </p>

        <p className="mx-auto mt-10 flex max-w-3xl items-start gap-3 rounded-2xl border border-primary bg-background p-6 text-left text-lg font-semibold leading-relaxed text-foreground shadow-lg shadow-primary/10" data-id="element-198" data-mp="13xwvpf6l7p1g">
          <CheckIcon className="glow-led mt-1 h-6 w-6 shrink-0 text-highlight" aria-hidden="true" data-id="element-199" data-mp="tz7d1k6va0k5" />
          A complete visual teaching system to take your students from the atom to organic chemistry and lab skills: clear
          diagrams, worked examples, key takeaways and common student misconceptions, organised into {totalVolumes} volumes
          ready to project in your classroom.
        </p>
      </div>
    </section>;
}